import { BOT_COLORS, parseBotAvatarValue, WAFI_AVATAR } from "@rakazo/contracts";
import { avatarIdentitySeed } from "./avatar-shape.js";
import { WAFI_HUE_IMAGES } from "./wafi-avatar-images.js";

/** One mark across all clients, including legacy sets, shapes and uploaded values. */
export function wafiAvatarImage(value: string, identity = ""): string {
  if (
    value === WAFI_AVATAR ||
    identity === "onboarding:first" ||
    identity === "first" ||
    (!value && !identity)
  )
    return WAFI_AVATAR;
  const parsed = parseBotAvatarValue(value);
  const color = "color" in parsed ? parsed.color : "";
  const paletteIndex = BOT_COLORS.findIndex((entry) => entry.toLowerCase() === color.toLowerCase());
  if (paletteIndex >= 0) return WAFI_HUE_IMAGES[paletteIndex + 1]!;
  // Legacy custom colours retain their hue; unknown values use stable identity.
  let step = 1 + (avatarIdentitySeed(identity || value) % 7);
  if (/^#(?:[a-f\d]{3}|[a-f\d]{6})$/i.test(color)) {
    const hex =
      color.slice(1).length === 3
        ? color
            .slice(1)
            .split("")
            .map((c) => c + c)
            .join("")
        : color.slice(1);
    const [r, g, b] = [0, 2, 4].map(
      (offset) => Number.parseInt(hex.slice(offset, offset + 2), 16) / 255,
    );
    const max = Math.max(r!, g!, b!);
    const delta = max - Math.min(r!, g!, b!);
    if (delta > 0) {
      const hue =
        max === r
          ? ((g! - b!) / delta) % 6
          : max === g
            ? (b! - r!) / delta + 2
            : (r! - g!) / delta + 4;
      step = 1 + (((Math.round((hue * 60 - 240) / 45) % 7) + 7) % 7);
    }
  }
  return WAFI_HUE_IMAGES[step]!;
}
